const crypto = require('../crypto')

export default class Anexos {
  constructor (source, q) {
    this.source = source
    this.q = q
    // Metodos
    /**
     * Obtiene úna lista de entidades sin filtrar
     */
    this.getKeyByPublic = (publicIdentifier) => {
      const defer = q.defer()
      this.source.SendRequest('GET', 'keys', { identifier: publicIdentifier }).then((rta) => {
        defer.resolve(rta)
      }).catch((err) => {
        defer.reject(err)
      })
      // retornamos la promesa
      return defer.promise
    }

    this.getUsuarioByCredentials = (email, password, forDev = false) => {
      const defer = q.defer()
      this.source.SendRequest('GET', 'usuariosCredentials', { email, password: crypto.GenerateHASH(password), forDev }).then((rta) => {
        defer.resolve(rta)
      }).catch((err) => {
        defer.reject(err)
      })
      // retornamos la promesa
      return defer.promise
    }

    this.createSesion = (keyapp, keyuser) => {
      const defer = q.defer()
      const explorer = this.source.GetClientInfo()
      this.source.SendRequest('POST', 'sesiones', null, { keyapp, keyuser, os: explorer.os, navegador: `${explorer.name}-${explorer.version}` }).then((rta) => {
        defer.resolve(rta)
      }).catch((err) => {
        defer.reject(err)
      })
      // retornamos la promesa
      return defer.promise
    }

    this.useSesion = (keyapp, sesion) => {
      const defer = q.defer()
      this.source.SendRequest('GET', 'sesionesUse', { keyapp, sesion }).then((rta) => {
        defer.resolve(rta)
      }).catch((err) => {
        defer.reject(err)
      })
      // retornamos la promesa
      return defer.promise
    }

    this.generateAuthCode = (email) => {
      const defer = q.defer()
      const explorer = this.source.GetClientInfo()
      this.source.SendRequest('POST', 'usuariosSendCode', { email, browser: `${explorer.name}-${explorer.version}` }).then((rta) => {
        defer.resolve(rta)
      }).catch((err) => {
        defer.reject(err)
      })
      // retornamos la promesa
      return defer.promise
    }

    this.UseAuthCode = (email, code) => {
      const defer = q.defer()
      this.source.SendRequest('POST', 'usuariosUseCode', { email, code }).then((rta) => {
        defer.resolve(rta)
      }).catch((err) => {
        defer.reject(err)
      })
      // retornamos la promesa
      return defer.promise
    }

    this.ChangePassword = (email, pass) => {
      const defer = q.defer()
      this.source.SendRequest('POST', 'usuariosChangePassword', { email, pass: crypto.GenerateHASH(pass) }).then((rta) => {
        defer.resolve(rta)
      }).catch((err) => {
        defer.reject(err)
      })
      // retornamos la promesa
      return defer.promise
    }

    this.GetSesionesPag = (sesion, devappauto, identificacion, fechainicio1, fechainicio2, lim = 0, offs = 0) => {
      const defer = q.defer()
      this.source.SendRequest('GET', 'sesionesPag', { devappauto, identificacion, fechainicio1, fechainicio2, lim, offs }, null, { oauth_ssn: sesion }).then((rta) => {
        defer.resolve(rta)
      }).catch((err) => {
        defer.reject(err)
      })
      // retornamos la promesa
      return defer.promise
    }
  }
}
